import { style } from 'styled-system';

const tableLayout = style({
  prop: 'tableLayout',
  cssProperty: 'tableLayout'
});

export default tableLayout;
